import axios from "axios";
import { getRequestOptions } from "../../resources/configs/requests";
import { GET_QUEUE_STATUS_AND_JOURNEY_URL } from "../../resources/configs/URL";
import { formatGetQueueStatusAndJourneyErrorMessage } from "../../resources/messages/ErrorMessage";
import { GetQueueStatusAndJourneyPayload } from "./getQueueStatusAndJourney.fromApi.types";
import { parseResponse } from "../../resources/handlers/parseResponse/parseResponse";

/**
 * The function `getQueueStatusAndJourney` is an asynchronous function that takes in several parameters
 * and makes a POST request to a specified URL to get the queue status and journey information.
 * @param {string | null} memberIdentifier - The memberIdentifier is a string that represents the
 * identifier of a member. It could be a unique identifier such as a membership number or a user ID.
 * @param {string | null} encounterId
 * @param {string | null} appointmentTime - The `appointmentTime` parameter is a string that represents
 * the time of the appointment.
 * @param {string | null} vcSupportStatus - Indicate a vcp appointment if vcSupportStatus == "supported"
 * @returns a Promise that resolves to a `GetQueueStatusAndJourneyPayload` object.
 */
const getQueueStatusAndJourney = async (
  memberIdentifier: string | null,
  encounterId: string | null,
  appointmentTime: string | null,
  vcSupportStatus: string | null,
): Promise<GetQueueStatusAndJourneyPayload> => {
  try {
    const response = await axios.post<GetQueueStatusAndJourneyPayload>(
      GET_QUEUE_STATUS_AND_JOURNEY_URL(),
      createRequestPayload(
        memberIdentifier,
        encounterId,
        appointmentTime,
        vcSupportStatus,
      ),
      getRequestOptions(),
    );
    return parseResponse(response, GET_QUEUE_STATUS_AND_JOURNEY_URL());
  } catch (error) {
    const msg = formatGetQueueStatusAndJourneyErrorMessage(
      GET_QUEUE_STATUS_AND_JOURNEY_URL(),
    );
    console.error(msg);
    throw error;
  }
};

const createRequestPayload = (
  memberIdentifier: string | null,
  encounterId: string | null,
  appointmentTime: string | null,
  vcSupportStatus: string | null,
) => {
  return {
    MemberIdentifier: memberIdentifier,
    EncounterId: encounterId,
    AppointmentTime: appointmentTime,
    VcSupportStatus: vcSupportStatus,
  };
};

export { getQueueStatusAndJourney };
